import { NavLink, Outlet, useParams } from "react-router-dom";
import { Github, Globe, History, Info, Layers, Users } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Org settings area — Overview / Members / Domains / Audit as tabs, each
 * its own route so state (e.g. an in-progress invite form) doesn't reset
 * when switching tabs. Mirrors AccountLayout/AdminLayout's sub-nav pattern.
 */
export function OrgSettingsLayout() {
  const { org } = useParams<{ org: string }>();

  const TABS = [
    { to: `/orgs/${org}/settings`, label: "Overview", icon: Info, end: true },
    { to: `/orgs/${org}/settings/members`, label: "Members", icon: Users, end: false },
    { to: `/orgs/${org}/settings/domains`, label: "Domains", icon: Globe, end: false },
    { to: `/orgs/${org}/settings/env-groups`, label: "Env groups", icon: Layers, end: false },
    { to: `/orgs/${org}/settings/github`, label: "GitHub", icon: Github, end: false },
    { to: `/orgs/${org}/settings/audit`, label: "Audit log", icon: History, end: false },
  ];

  return (
    <div className="container max-w-screen-xl py-6">
      <div className="mb-4">
        <h1 className="text-xl font-semibold tracking-tight">Settings</h1>
        <p className="text-xs text-muted-foreground mt-0.5">
          Organization settings for <span className="font-mono">{org}</span>
        </p>
      </div>
      <nav className="of-tabstrip -mt-1 mb-5">
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            className={({ isActive }) =>
              cn(
                "inline-flex shrink-0 items-center gap-1.5 h-9 px-2.5 text-sm whitespace-nowrap text-muted-foreground border-b-2 border-transparent hover:text-foreground transition-colors",
                isActive && "text-foreground border-[rgb(var(--of-fg-default))] font-semibold",
              )
            }
          >
            <t.icon className="h-3.5 w-3.5" />
            {t.label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  );
}
